import { render, staticRenderFns } from "./AgentSidebar.vue?vue&type=template&id=d51add24"
import script from "./AgentSidebar.vue?vue&type=script&lang=js"
export * from "./AgentSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports